import { useState } from "react";
import { fetchPatientBills } from "../../utils/patients/fetchPatientsBills";
import { bookAppointment } from "../../utils/patients/bookAppointment";
import { fetchDoctors } from "../../utils/patients/fetchDoctors";
import { CancelAppointment } from "../../utils/patients/cancelAppointment";
import { reScheduleAppointment } from "../../utils/patients/reScheduleAppointment";
import { toast } from "sonner";
import { fetchDepartments } from "../../utils/patients/fetchDepartments";
import { fetchAvailability } from "../../utils/patients/dashboard/fetchAvailability";
import useProfileStore from "../../store/patient/profileStore";
import { useNavigate } from "react-router-dom";

const useManageAppointment = () => {

  const [loading, setLoading] = useState(false);
  const [doctors, setDoctors] = useState();
  const [loadingDr, setLoadingDr] = useState(); 
  const [departments, setDepartments] = useState([]) 
  const {profile} = useProfileStore()
  const [booking, setBooking]= useState(false)
  const navigate = useNavigate()
 

  

  // id = 27503
  const handleBookAppointment = async (data) => {
    setLoading(true);
    setBooking(true)
    await bookAppointment(data)
    .then((res) => {
        setLoading(false);
        setBooking(false)
        toast.success("Appointment Booked successful!");
        navigate("/dashboard/myappointment#upcoming")
      })
      .catch((err) => {
        setBooking(false)
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
      });
  };

  const handleFetchAllDoctors = async (data) => {
    setLoadingDr(true);
    await fetchDoctors(data)
    .then((res) => {
        setLoadingDr(false);
        setDoctors(res?.data)
      })
      .catch((err) => {
        window.location.href = "/pages/signin2";
        console.log("error error");
        setLoadingDr(false);
      });
  };

  const handleFetchAllDepartments = async (data) => {
    setLoading(true);
    await fetchDepartments(data)
    .then((res) => {
        setLoadingDr(false);
        setDepartments(res?.data)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
      });
  };

  const handleCheckAvailability = async (data) => {
    setLoadingDr(true);
    await fetchAvailability(data)
    .then((res) => {
        setLoadingDr(false);
        setDoctors(res?.data)
      })
      .catch((err) => {
        setLoadingDr(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
      });
  };


  const handleCancelAppointment = async (appointmentId) => {
    setLoading(true);
    try {
      await CancelAppointment(appointmentId);
      setLoading(false);
      toast.success("Appointment cancelled successfully!");
    } catch (err) {
      setLoading(false);
      toast.error("Failed to cancel appointment.");
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
  };

  const handleReScheculeAppointment = async (data) => {
    setLoading(true);
    try {
      await reScheduleAppointment(data);
      setLoading(false);
      toast.success("Appointment Schedulled successfully!");
    } catch (err) {
      setLoading(false);
      toast.error("Failed to schedule appointment.");
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
  };


  return {
    handleBookAppointment,
    handleFetchAllDoctors,
    handleReScheculeAppointment,
    loading,
    doctors,
    loadingDr,
    setLoading,
    setLoadingDr,
    handleBookAppointment,
    handleReScheculeAppointment,
    handleFetchAllDepartments,
    departments,
    booking,
    handleCheckAvailability,
    setDepartments,

  };
};

export default useManageAppointment;